export interface PatientDashboardTranslations {
  toDo: string;
  loading: string;
  nothingAvailableDescriptor: string;
  selfCheck: string;
  assessments: {
    title: string;
    current: string;
    history: string;
  },
}

export const patientDashboardTranslationKeys: PatientDashboardTranslations = {
  toDo: 'toDo',
  loading: 'loading',
  nothingAvailableDescriptor: 'nothingAvailableDescriptor',
  selfCheck: 'selfCheck',
  assessments: {
    title: 'assessments.title',
    current: 'assessments.current',
    history: 'assessments.history',
  },
};

export const patientDashboardTranslationsEN: PatientDashboardTranslations = {
  toDo: 'To-Do',
  loading: 'Loading...',
  nothingAvailableDescriptor: 'Nothing available at this time, please check back later.',
  selfCheck: 'Self-Check',
  assessments: {
    title: 'Assessments',
    current: 'Current',
    history: 'History',
  },
};

export const patientDashboardTranslationsES: PatientDashboardTranslations = {
  toDo: 'Por hacer',
  loading: 'Cargando...',
  nothingAvailableDescriptor: 'No hay nada disponible en este momento, por favor vuelva a intentarlo más tarde.',
  selfCheck: 'Autoevaluación',
  assessments: {
    title: 'Evaluaciones',
    current: 'Actual',
    history: 'Historial',
  },
};
